import { MAJORS } from "../../constants";

export default {
  created() {
    this.MAJORS = MAJORS;
  },
  methods: {
    searchMajor(options, search) {
      return search.length
        ? options.filter(major =>
          major.label.toLowerCase().includes(search.toLowerCase())
        )
        : options;
    },
  },
};